module.exports = __webpack_public_path__ + "img/26-jeep-alt.892d3c83.png";